import * as yup from "yup";

export const validation = yup.object().shape({
  cuit: yup
    .number()
    .typeError("Ingrese un n° de CUIT sin guiones")
    .min(100000000, "Debe ser un CUIT válido")
    .required("Este campo es obligatorio"),
    email: yup
      .string()
      .email("debe ser un domicilio electrónico válido")
      .required("Este campo es obligatorio"),
  domicilio_fiscal: yup.string().required("Este campo es obligatorio"),
  telefono: yup
    .number()
    .typeError("Ingrese un n° de telefono")
    .min(100000, "Debe ser un N° de telefono válido")
    .required("Este campo es obligatorio"),
    lastname_titular: yup.string().required("Este campo es obligatorio"),
    firstname_titular: yup.string().required("Este campo es obligatorio"),
    dni_titular: yup
    .number()
    .typeError("Ingrese un n° de DNI")
    .min(10000000, "Debe ser un DNI válido")
    .required("Este campo es obligatorio"),
    domicilio_titular: yup.string().required("Este campo es obligatorio"),
    marca: yup.string().required("Este campo es obligatorio"),
    modelo: yup.string().required("Este campo es obligatorio"),
    dominio: yup.string().required("Este campo es obligatorio"),
    motor: yup.string().required("Este campo es obligatorio"),
    color: yup.string().required("Este campo es obligatorio"),
    propietario: yup.string().required("Debe completar este campo con su nombre y apellido"),
});

